import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {IHotel, ICar, ICondo, IShareCompareState } from '@share/common-types';

const initialState: IShareCompareState = {
  hotelcompare: [],
  carscompare: [],
  condoscompare: [],
  hotelCompareStartDate: null,
  hotelCompareEndDate: null,
  carCompareStartDate: null,
  carCompareEndDate: null,
  carCompareStartDateTime: null,
  carCompareEndDateTime: null,
  carCompareDriverAge: null,
  carCompareDriverCountry: null,
  condoscompareStartDate:null,
  condoscompareEndDate: null,
  condoscompareMonth: [],
  condoscompareSearch: null
};

const compareSlice = createSlice({
  name: 'compare',
  initialState,
  reducers: {
    // Hotel Compare Actions--------------------------------------------
    setHotelToCompare(state, action: PayloadAction<IHotel[]>) {
      state.hotelcompare = action.payload;
    },
    setremoveHotelFromCompare(state, action: PayloadAction<number>) {
      state.hotelcompare = state.hotelcompare.filter(h => h.hotelId !== action.payload);
    },
    setclearHotelsCompare(state) {
      state.hotelcompare = [];
    },

    setHotelCompareStartDate(state, action: PayloadAction<string | null>) {
      state.hotelCompareStartDate = action.payload;
    },

    setHotelCompareEndDate(state, action: PayloadAction<string | null>) {
      state.hotelCompareEndDate = action.payload;
    },

    // Cars Compare Actions--------------------------------------------
    setCarToCompare(state, action: PayloadAction<ICar[]>) {
      state.carscompare = action.payload;
    },
    setremoveCarFromCompare(state, action: PayloadAction<string>) {
      state.carscompare = state.carscompare.filter(c => c.id !== action.payload);
    },
    setclearCarsCompare(state) {
      state.carscompare = [];
    },

    setCarCompareStartDate(state, action: PayloadAction<string | null>) {
      state.carCompareStartDate = action.payload;
    },

    setCarCompareEndDate(state, action: PayloadAction<string | null>) {
      state.carCompareEndDate = action.payload;
    },

    setCarCompareStartDateTime(state, action: PayloadAction<string | null>) {
      state.carCompareStartDateTime = action.payload;
    },

    setCarCompareEndDateTime(state, action: PayloadAction<string | null>) {
      state.carCompareEndDateTime = action.payload;
    },

    setCarCompareDriverAge(state, action: PayloadAction<string | null>) {
      state.carCompareDriverAge = action.payload;
    },

    setCarCompareDriverCountry(state, action: PayloadAction<string | null>) {
      state.carCompareDriverCountry = action.payload;
    },

// Condos Compare Actions--------------------------------------------
    setCondoToCompare(state, action: PayloadAction<ICondo[]>) {
      state.condoscompare = action.payload;
    },
    setremoveCondoFromCompare(state, action: PayloadAction<number>) {
      state.condoscompare = state.condoscompare.filter(c => c.condoId !== action.payload);
    },
    setclearCondoCompare(state) {
      state.condoscompare = [];
    },
    
    setCondoCompareStartDate(state, action: PayloadAction<string | null>) {
      state.condoscompareStartDate = action.payload;
    },

    setCondoCompareEndDate(state, action: PayloadAction<string | null>) {
      state.condoscompareEndDate = action.payload;
    },

    setcondoscompareMonth(state, action: PayloadAction<string[] | null>) {
      state.condoscompareMonth = action.payload;
    },

    setcondoscompareSearch(state, action: PayloadAction<string | null>) {
      state.condoscompareSearch = action.payload;
    },

    // all data clear-----------------------------------------------------------
    setclearAllCompare(state) {
      state.hotelcompare = [];
      state.carscompare = [];
      state.condoscompare = [];
    },

    setclearFullCondosCompare(state) {
      state.condoscompare = [];
      state.condoscompareStartDate = null;
      state.condoscompareEndDate = null;
      state.condoscompareMonth = null;
      state.condoscompareSearch = null;
    },
    setclearFullCarsCompare(state) {
      state.carscompare = [];
      state.carCompareStartDate = null;
      state.carCompareEndDate = null;
    },
    setclearFullHotelsCompare(state) {
      state.hotelcompare = [];
      state.hotelCompareStartDate = null;
      state.hotelCompareEndDate = null;
    },
  },
});

export const compareActions = compareSlice.actions;

export const compareReducer = compareSlice.reducer;
